import { Backdrop, Link, SHADOW_LEVEL1, styled } from '@ori-ui/mui';

import { CSS_DESKTOP_HEIGHT, CSS_DESKTOP_INNER_HEIGHT, CSS_HEIGHT_ANIMATION } from '../../constants';

export const SearchResultsRoot = styled('div')(({ theme }) => ({
  background: theme.palette.common.white,
  boxShadow: SHADOW_LEVEL1,
  boxSizing: 'border-box',
  color: theme.palette.text.primary,
  display: 'flex',
  flexDirection: 'column',
  left: 0,
  padding: theme.spacing(14, 3, 3),
  position: 'absolute',
  top: CSS_DESKTOP_INNER_HEIGHT,
  transition: `top ${CSS_HEIGHT_ANIMATION}`,
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: `calc(100% - var(--minibag-desktop-width, 0px))`,
    padding: theme.spacing(6, 12),
  },
}));

export const SearchResultsContentWrapper = styled('div')<{ ownerState: { innerHeight: number } }>(({
  ownerState: { innerHeight },
  theme,
}) => {
  const rootPaddings = theme.spacing(17);

  return {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: `calc(${innerHeight}px - ${rootPaddings} - ${CSS_DESKTOP_HEIGHT}`,
    minHeight: 100,
    position: 'relative',
    width: '100%',

    [theme.breakpoints.down('md')]: {
      overflowY: 'auto',
      overscrollBehaviorY: 'contain',
    },

    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gridTemplateColumns: '30% 70%',
      gridTemplateRows: '29px auto',
    },
  };
});

export const SearchResultsHeader = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  margin: theme.spacing(1, 0, 4),

  [theme.breakpoints.up('md')]: {
    gridColumn: 1,
    gridRow: 1,
    margin: 0,
    marginTop: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export const SearchResultsQuery = styled(Link)(({ theme }) => ({
  borderBottom: `2px solid ${theme.palette.text.primary}`,
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightBold,
  marginLeft: 3,
  paddingBottom: 3,
  textDecoration: 'none',

  '&:hover, &:focus, &:active': {
    borderBottom: `2px solid ${theme.palette.text.disabled}`,
    color: theme.palette.text.disabled,
  },
}));

export const SearchResultsLeftSide = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    gridColumn: 1,
    gridRow: 2,
  },
}));

export const SearchResultsLoader = styled('span')(({ theme }) => ({
  top: '60%',

  [theme.breakpoints.up('md')]: {
    top: '50%',
  },
}));

export const CustomBackdrop = styled(Backdrop)(() => ({
  position: 'absolute',
  zIndex: '-1',
  width: '100vw',
  height: '100vh',
}));
